<app-hero></app-hero>
<app-problem></app-problem>
<app-solution></app-solution>
<app-testimonials></app-testimonials>
<app-pricing></app-pricing>
<app-faq></app-faq>
